import { Select, SelectProps } from "@cofano/cck";
import { Constraint } from "__generated__/enums";
import { intl } from "LocaleWrapper";

const CallProgressSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<Constraint, Multiple>, "fetchOptions" | "paginated" | "getOptionLabel" | "disableSearch">) => {
	return (
		<Select
			{...rest}
			fetchOptions={Object.values(Constraint)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			disableSearch />
	);
};

export default CallProgressSelect;
